import { useDispatch, useSelector } from "react-redux";
import Modal from "react-bootstrap/Modal";
import { closeModal } from "../store/alternateArt";
import styles from "../styles/AlternateArtModal.module.scss";
import { updateProfile } from "../store/auth";
import { v4 } from "uuid";

const AlternateArtModal = () => {
  const dispatch = useDispatch();
  const card = useSelector((state) => state.alternateArt.card);
  const isOpen = useSelector((state) => state.alternateArt.isOpen);

  if (!isOpen) return null;

  return (
    <Modal
      className={styles.container}
      dialogClassName={styles.dialog}
      onHide={() => dispatch(closeModal())}
      show={isOpen}
    >
      <Modal.Body>
        <div className={styles.cards}>
          {card?.unique_artwork?.map(({ artist, collector_number, set, set_name, image_uris }) => (
            <div
              className={styles.cardContainer}
              key={v4()}
              onClick={() => {
                dispatch(
                  updateProfile({
                    alternateArt: { [card.url]: image_uris },
                  })
                );
              }}
            >
              <div>
                <img alt={`${set} ${collector_number}`} className={styles.card} src={image_uris[0]} />
              </div>
              <div className={styles.label}>
                <div className={styles.set}>{set_name}</div>
                <div>Artist: {artist}</div>
              </div>
            </div>
          ))}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AlternateArtModal;
